export interface PlatformCapability {
  label: string
}

/** The shared core beneath both commercial experiences. */
export const sharedCapabilities: PlatformCapability[] = [
  { label: 'Voice' },
  { label: 'Telephony' },
  { label: 'Memory' },
  { label: 'Actions' },
]

export interface GoLiveStep {
  index: string
  label: string
}

export const goLiveSteps: GoLiveStep[] = [
  { index: '01', label: 'Configure' },
  { index: '02', label: 'Forward' },
  { index: '03', label: 'Live' },
]

export interface BusinessChannel {
  id: 'voice' | 'whatsapp' | 'integrations' | 'workflows'
  label: string
  caption: string
  detail?: string
}

/** What the same engine becomes for a business. */
export const businessChannels: BusinessChannel[] = [
  { id: 'voice', label: 'Voice', caption: 'AI call handling' },
  { id: 'whatsapp', label: 'WhatsApp', caption: 'AI conversations' },
  {
    id: 'integrations',
    label: 'Integrations',
    caption: 'Connect business tools',
    detail: 'CRM · Calendar · Email',
  },
  {
    id: 'workflows',
    label: 'Workflow builder',
    caption: 'Automate conversations & actions',
    detail: 'Visual AI workflow builder',
  },
]

/** Illustrative of deployment complexity — not a claim about any one vendor. */
export const typicalDeployment = [
  'SIP',
  'SBC',
  'Call centre',
  'AI',
  'Integration',
  'Deploy',
]
